import axios from "axios";

export const getToken = async () => {
  return "Jai Shree Swaminarayan";
  const CLIENT_ID = "77hlnj1oe0mpbsq1g5pg36va5e";
  const CLIENT_SECRET = "1422dv5fm5vajajkqqs6q7mc2c9smv4fo18maamvaamf64rjglpb";

  let formData = new URLSearchParams();
  formData.append("grant_type", "client_credentials");
  formData.append("client_id", CLIENT_ID);
  formData.append("client_secret", CLIENT_SECRET);

  let tokenData = localStorage.getItem("access_token");
  if (tokenData) {
    let token = tokenData.token;
    let timestamp = new Date(tokenData.timestamp);

    if (timestamp >= new Date()) {
      return token;
    }
  }

  //   var details = {
  //     grant_type: "client_credentials",
  //     client_id: CLIENT_ID,
  //     client_secret: CLIENT_SECRET,
  //   };

  //   var formBody = [];
  //   for (var property in details) {
  //     var encodedKey = encodeURIComponent(property);
  //     var encodedValue = encodeURIComponent(details[property]);
  //     formBody.push(encodedKey + "=" + encodedValue);
  //   }
  //   formBody = formBody.join("&");
  //   const res = await fetch(
  //     "https://wadhwan-mandir-api-prod.auth.ap-south-1.amazoncognito.com//oauth2/token",
  //     {
  //       method: "POST",
  //       body: formData,
  //       headers: {
  //         "Content-Type": "application/x-www-form-urlencoded",
  //       },
  //     }
  //   ).then((e) => e);
  //   console.log(res);

  const res = await axios
    .post(
      "https://wadhwan-mandir-api-prod.auth.ap-south-1.amazoncognito.com//oauth2/token",
      formData,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    )
    .then((res) => {
      const resTokenData = {
        token: res?.data.access_token,
        timestamp: new Date(new Date().getTime() + 60 * 60000),
      };
      localStorage.setItem("access_token", resTokenData);
      return resTokenData.token;
    });
  return res;
};
